/**
 * B2B 注册 — 方案 A：multipart POST 至后端代创建客户并置 b2b_status=pending。
 * 契约见 docs/INTEGRATION.md「B2B 注册 API」。
 */
(function () {
  'use strict';
  var REF_COOKIE = 'pet_referral_code';

  function readReferralCodeFromCookie() {
    var escaped = REF_COOKIE.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    var m = document.cookie.match(new RegExp('(?:^|; )' + escaped + '=([^;]*)'));
    if (!m || !m[1]) return '';
    try {
      return decodeURIComponent(m[1]).trim();
    } catch (e) {
      return String(m[1] || '').trim();
    }
  }

  function getReferralCode() {
    try {
      var p = new URLSearchParams(window.location.search || '');
      var q = (p.get('ref') || p.get('referral_code') || '').trim();
      if (q) return q;
    } catch (e) {}
    return readReferralCodeFromCookie();
  }

  function getDeviceId() {
    var key = 'pet_device_id';
    try {
      var v = localStorage.getItem(key) || '';
      if (v) return v;
      v = 'dev_' + Math.random().toString(36).slice(2, 10) + Date.now().toString(36);
      localStorage.setItem(key, v);
      return v;
    } catch (e) {
      return '';
    }
  }

  async function sha256Hex(text) {
    if (!text || !window.crypto || !window.crypto.subtle || !window.TextEncoder) return '';
    try {
      var buf = new TextEncoder().encode(text);
      var hash = await window.crypto.subtle.digest('SHA-256', buf);
      return Array.from(new Uint8Array(hash))
        .map(function (b) { return b.toString(16).padStart(2, '0'); })
        .join('');
    } catch (e) {
      return '';
    }
  }

  function getMessages(root) {
    var id = root.getAttribute('data-msgs-id');
    var node = id ? document.getElementById(id) : null;
    try {
      return JSON.parse((node && node.textContent) || '{}');
    } catch (e) {
      return {};
    }
  }

  function setStatus(el, type, text) {
    if (!el) return;
    el.hidden = !text;
    el.textContent = text || '';
    el.className = 'b2b-register__api-status b2b-register__api-status--' + (type || 'info');
    el.setAttribute('role', 'alert');
  }

  function init(root) {
    if (!root || root.getAttribute('data-b2b-register-init') === '1') return;
    root.setAttribute('data-b2b-register-init', '1');
    var form = root.querySelector('[data-b2b-register-form]');
    var statusEl = root.querySelector('[data-b2b-register-status]');
    var submitBtn = root.querySelector('[data-b2b-submit]');
    var referralInput = root.querySelector('[data-referral-code-input]');
    var msg = getMessages(root);
    if (!form) return;

    if (referralInput && !referralInput.value) {
      var initialReferralCode = getReferralCode();
      if (initialReferralCode) {
        referralInput.value = initialReferralCode;
      }
    }

    var fileInput = root.querySelector('[data-b2b-file-input]');
    var fileNameEl = root.querySelector('[data-b2b-file-name]');
    if (fileInput && fileNameEl) {
      var noneText = fileInput.getAttribute('data-text-none') || '';
      var manyText = fileInput.getAttribute('data-text-many') || '';
      var updateFileName = function () {
        var files = fileInput.files;
        var n = files ? files.length : 0;
        if (n === 0) {
          fileNameEl.textContent = noneText;
        } else if (n === 1) {
          fileNameEl.textContent = files[0].name;
        } else {
          fileNameEl.textContent = manyText.replace('{{ count }}', n);
        }
      };
      fileInput.addEventListener('change', updateFileName);
    }

    var base = (window.loyaltyApiBaseUrl || '').replace(/\/$/, '');
    var path = root.getAttribute('data-endpoint-path') || '/api/shopify/b2b-register';
    var url = base ? base + path : '';

    form.addEventListener('submit', async function (e) {
      e.preventDefault();
      if (!url) {
        setStatus(statusEl, 'error', msg.missing_api || '');
        return;
      }
      setStatus(statusEl, 'info', msg.submitting || '');

      var fd = new FormData(form);
      fd.set('shop_domain', root.getAttribute('data-shop-domain') || '');
      var cid = root.getAttribute('data-customer-id');
      if (cid) fd.set('shopify_customer_id', cid);
      var deviceId = getDeviceId();
      if (deviceId) fd.set('device_id', deviceId);
      var uaHash = await sha256Hex(navigator.userAgent || '');
      if (uaHash) fd.set('ua_hash', uaHash);

      if (submitBtn) submitBtn.disabled = true;

      fetch(url, {
        method: 'POST',
        body: fd,
        headers: {
          Accept: 'application/json',
        },
      })
        .then(function (r) {
          return r.text().then(function (t) {
            var data = null;
            try {
              data = t ? JSON.parse(t) : null;
            } catch (err) {
              data = { raw: t };
            }
            return { ok: r.ok, status: r.status, data: data };
          });
        })
        .then(function (res) {
          if (res.ok && res.data && (res.data.success === true || res.data.status === 'ok')) {
            try {
              sessionStorage.setItem('pet_b2b_submit_ok', '1');
            } catch (err) {}
            setStatus(statusEl, 'success', msg.success || '');
            form.reset();
            return;
          }
          var errText =
            (res.data && (res.data.message || res.data.error)) ||
            (msg.error_prefix || '') + ' (' + res.status + ')';
          setStatus(statusEl, 'error', errText);
        })
        .catch(function () {
          setStatus(statusEl, 'error', msg.network || '');
        })
        .finally(function () {
          if (submitBtn) submitBtn.disabled = false;
        });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-b2b-register-root]').forEach(init);
  });
})();
